export const BuilderPalRoleType = {
  ASSISTANT: 'assistant',
  USER: 'user',
};

export const builderPalRoleTypes = [
  BuilderPalRoleType.ASSISTANT,
  BuilderPalRoleType.USER,
];
